module.exports = __webpack_public_path__ + "img/square-w.39511d69.svg";